import { Chip } from '@mui/material';
import { tokens } from '../../theme';

const labels = {
  document: 'Document',
  video: 'Video',
  audio: 'Audio',
  scorm: 'SCORM',
  // The other types the server reads from an item's address (utils/contentType.js), so Content Health's Type column
  // names them too (N5 pt 15).
  image: 'Image',
  url: 'Link',
  article: 'Article',
  course: 'Course',
  'learning path': 'Learning Path',
};

const compactLabels = {
  course: 'C',
  'learning path': 'LP',
  module: 'M',
};

export default function TypeTag({ type, compact = false }) {
  const normalizedType = String(type ?? '')
    .replace(/\*/g, '')
    .trim()
    .toLowerCase();

  const label = compact
    ? (compactLabels[normalizedType] ??
       labels[normalizedType] ??
       normalizedType)
    : (labels[normalizedType] ?? normalizedType);

  return (
    <Chip
      size="small"
      label={label}
      variant="outlined"
      sx={{
        border: `1px solid ${tokens.color.brand}`,
        backgroundColor: tokens.color.brandLight,
        color: tokens.color.brand,
        fontWeight: 700,
        height: 24,
        '& .MuiChip-label': { px: 1 },
        minWidth: 24,
      }}
    />
  );
}